import * as Sentry from "@sentry/react";

Sentry.init({
  // dsn: 'https://fcc80df1b5effa00928349ebb472a186@o4508289154351104.ingest.us.sentry.io/4509794828025856',
  dsn: "https://b9e0cf78258f66a65aa2e78146db95dd@o4509890141224960.ingest.us.sentry.io/4509954854682624",
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
});
